import React from 'react';
import LeftBar from '../Components/LeftBar';
import Dashnav from '../Components/Dashnav';
import SecondaryCoursesComp from './SecondaryCoursesComp';

function SecondaryCourses() {
  return (
    <div className='mainContainer'>
      <LeftBar />
      <div className='theMainContainer'>
        <Dashnav />
        <SecondaryCoursesComp />
      </div>
    </div>
  );
}

export default SecondaryCourses;
